module.exports = __webpack_public_path__ + "media/images/emoticons/one-5a4b12a9c5e3b9e466659d507b106122.gif";